function buttonLink(hreflink) {
    location.href = hreflink
}
